import React from 'react';

import styled from 'styled-components';

import { colorMaps, spacing } from '@sine/sine-ui-components';

interface MiddleDotSeparatorProps {
  variant?: 'light' | 'dark';
}

const Wrapper = styled.span`
  display: inline-flex;
  align-items: center;
  margin: auto ${spacing(1)};
`;

const Dot = styled.span<MiddleDotSeparatorProps>`
  height: 4px;
  width: 4px;
  background: ${({ variant }) => (variant === 'dark' ? colorMaps.text.text80 : colorMaps.text.text68)};
  border-radius: 100%;
  display: inline;
`;

function MiddleDotSeparator({ variant }: MiddleDotSeparatorProps) {
  return (
    <Wrapper>
      <Dot variant={variant} />
    </Wrapper>
  );
}

export default MiddleDotSeparator;
